// src/pages/Home/components/AtalhosSection.js
//
// Atalhos de busca. Ocupa o lugar que era do bloco de blog na home.
//
// Duas razoes para existir, alem da obvia:
//
// 1. Quem chega na home nao sabe o que digitar. Um campo de busca vazio e
//    uma pergunta; um atalho e uma resposta. Marketplace sem atalho perde a
//    visita de quem ainda nao decidiu o que procura.
// 2. Rastreador de busca so encontra pagina que tem link apontando para ela.
//    As quatro paginas de Chapeco existiam sem nenhum link na home.
//
// REGRA: so entra atalho para destino que EXISTE. Sem link para bairro sem
// pagina, sem cidade sem imovel. Link para lugar vazio decepciona a pessoa e
// ensina o buscador que o site tem pagina fraca.
import React from 'react'
import { Box, Chip, Stack, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import Secao from '../../../components/Layout/Secao'
import { evento } from '../../../analytics'

// Tipos aceitos por PROPERTY_TYPES no backend. Mudou la, muda aqui.
const TIPOS = [
  { rotulo: 'Casas', q: 'property_type=casa' },
  { rotulo: 'Apartamentos', q: 'property_type=apartamento' },
  { rotulo: 'Terrenos', q: 'property_type=terreno' },
  { rotulo: 'Comerciais', q: 'property_type=comercial' },
  { rotulo: 'Rurais', q: 'property_type=rural' }
]

const TRANSACOES = [
  { rotulo: 'À venda', q: 'transaction_type=venda' },
  { rotulo: 'Para alugar', q: 'transaction_type=aluguel' }
]

// Paginas reais em src/pages/Chapeco/chapecoContent.js. Nao inventar slug.
const GUIAS = [
  { rotulo: 'Comprar imóvel em Chapecó', para: '/chapeco/comprar-imovel' },
  { rotulo: 'Casas à venda em Chapecó', para: '/chapeco/casas-a-venda' },
  { rotulo: 'Apartamentos à venda em Chapecó', para: '/chapeco/apartamentos-a-venda' },
  { rotulo: 'Terrenos à venda em Chapecó', para: '/chapeco/terrenos-a-venda' }
]

const Grupo = ({ titulo, itens, tipo }) => (
  <Box>
    <Typography
      component='h3'
      sx={{
        fontSize: '.78rem',
        fontWeight: 700,
        letterSpacing: '.08em',
        textTransform: 'uppercase',
        color: 'text.secondary',
        mb: 1.5
      }}
    >
      {titulo}
    </Typography>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {itens.map((it) => (
        <Chip
          key={it.rotulo}
          label={it.rotulo}
          component={RouterLink}
          to={it.para || `/imoveis?${it.q}`}
          clickable
          onClick={() => evento('atalho_clique', { atalho: it.rotulo, grupo: tipo })}
          sx={{
            fontWeight: 500,
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            '&:hover': { borderColor: 'primary.main', bgcolor: 'background.paper' }
          }}
        />
      ))}
    </Box>
  </Box>
)

const AtalhosSection = () => (
  <Secao fundo='padrao' ritmo='apertado'>
    <Typography
      component='h2'
      sx={{ fontSize: { xs: '1.35rem', md: '1.6rem' }, fontWeight: 700, mb: 0.5 }}
    >
      Por onde você quer começar
    </Typography>
    <Typography sx={{ color: 'text.secondary', mb: 3 }}>
      Chapecó e o Oeste de Santa Catarina.
    </Typography>

    {/* Empilhado, nao em tres colunas.
        A versao em grade forcava os tres grupos a disputar a mesma largura, e
        nao havia divisao que servisse aos tres: 4/3/5 quebrava "Rurais" para a
        segunda linha; 5/2/5 arrumava esse e quebrava "Negocio"; 5/3/4 arrumava
        os dois e jogava "Guias" para QUATRO linhas, um chip por linha.
        Empilhado, cada grupo usa o trilho inteiro e os tres cabem em uma linha
        cada - sem conta para refazer quando alguem adicionar um chip. */}
    <Stack spacing={{ xs: 2.5, md: 3 }}>
      <Grupo titulo='Tipo de imóvel' itens={TIPOS} tipo='tipo' />
      <Grupo titulo='Negócio' itens={TRANSACOES} tipo='transacao' />
      <Grupo titulo='Guias da região' itens={GUIAS} tipo='guia' />
    </Stack>
  </Secao>
)

export default AtalhosSection
